import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-[#0a1628] border-t border-[#1e3a5f]/30 py-6 md:py-8 pb-20 md:pb-8" data-id="element-85">
        <div className="max-w-4xl mx-auto px-5 md:px-6" data-id="element-86">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-87">
            <p className="text-gray-500 text-sm" data-id="element-88">
              © {new Date().getFullYear()} Hábitos Atómicos Espirituales. Todos
              los derechos reservados.
            </p>

            <div className="flex items-center gap-6 text-sm" data-id="element-89">
              <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-[#d4af37] transition-colors" data-id="element-90">
                Política de Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-91">
        <div className="space-y-6" data-id="element-92">
          <section data-id="element-93">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-94">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-95">
              En Hábitos Atómicos Espirituales, recopilamos únicamente la
              información necesaria para procesar tu compra y entregarte el
              producto digital. Esto incluye:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-4" data-id="element-96">
              <li data-id="element-97">Nombre y dirección de correo electrónico</li>
              <li data-id="element-98">
                Información de pago (procesada de forma segura por nuestro
                proveedor de pagos)
              </li>
            </ul>
          </section>

          <section data-id="element-99">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-100">
              2. Uso de la Información
            </h3>
            <p data-id="element-101">Utilizamos tu información para:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-4" data-id="element-102">
              <li data-id="element-103">Procesar tu compra y entregarte acceso al producto</li>
              <li data-id="element-104">Enviarte actualizaciones importantes sobre tu compra</li>
              <li data-id="element-105">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section data-id="element-106">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-107">
              3. Protección de Datos
            </h3>
            <p data-id="element-108">
              Nos comprometemos a proteger tu información personal. No vendemos,
              alquilamos ni compartimos tu información con terceros, excepto
              cuando sea necesario para procesar tu compra (procesadores de
              pago).
            </p>
          </section>

          <section data-id="element-109">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-110">
              4. Cookies
            </h3>
            <p data-id="element-111">
              Utilizamos cookies esenciales para el funcionamiento del sitio web
              y para mejorar tu experiencia de usuario.
            </p>
          </section>

          <section data-id="element-112">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-113">
              5. Tus Derechos
            </h3>
            <p data-id="element-114">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal en cualquier momento. Para ejercer estos derechos,
              contáctanos directamente.
            </p>
          </section>

          <section data-id="element-115">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-116">
              6. Cambios a esta Política
            </h3>
            <p data-id="element-117">
              Nos reservamos el derecho de actualizar esta política de
              privacidad. Te notificaremos sobre cambios significativos por
              correo electrónico.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}